import { gql } from '@apollo/client';

export const GET_SUMMARY_REPORT = gql`
  query getFintelChecks($input: FintelCheckSearchInput!) {
    fintelChecks(input: $input) {
      count
      totalPages
      currentPage
      totalCounts {
        pageCount
        passCount
        failCount
        reviewCount
        incompleteCount
        nfCount
      }
      fintelChecks {
        id
        publisherName
        publisherId
        productCategory
        customizedProductId
        productName
        pageCount
        passCount
        failCount
        reviewCount
        incompleteCount
        nfCount
      }
    }
  }
`;
